document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    initProductFeaturesSlider();
    applyHeaderSpacingToContainer();
    initSectionAnimation();
  }, 100);

  window.addEventListener('resize', applyHeaderSpacingToContainer);
});

function initProductFeaturesSlider() {
  const sliderContainer = document.querySelector('.tw-product-features__swiper');
  if (!sliderContainer) return;
  if (sliderContainer.dataset.initialized === 'true') {
    return;
  }

  if (typeof Swiper === 'undefined') {
    return;
  }

  try {
    const swiper = new Swiper(sliderContainer, {
      slidesPerView: 1,
      spaceBetween: 25,
      loop: false,
      grabCursor: true,
      allowTouchMove: true,
      pagination: {
        el: '.tw-product-features__pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      },
      breakpoints: {
        375: { slidesPerView: 1.05, spaceBetween: 10 },
        640: { slidesPerView: 1.05, spaceBetween: 10 },
        768: { slidesPerView: 1.2, spaceBetween: 10 },
        1024: { slidesPerView: 3, spaceBetween: 25 },
        1280: { slidesPerView: 3, spaceBetween: 25 },
      },
    });

    // 绑定按钮事件
    const prevButtons = document.querySelectorAll('.tw-product-features__button--prev');
    const nextButtons = document.querySelectorAll('.tw-product-features__button--next');
    
    // 初始化按钮状态
    function updateButtonStates() {
      prevButtons.forEach(button => {
        if (swiper.isBeginning) {
          button.classList.add('swiper-button-disabled');
        } else {
          button.classList.remove('swiper-button-disabled');
        }
      });
      nextButtons.forEach(button => {
        if (swiper.isEnd) {
          button.classList.add('swiper-button-disabled');
        } else {
          button.classList.remove('swiper-button-disabled');
        }
      });
    }

    prevButtons.forEach(button => {
      button.addEventListener('click', () => {
        swiper.slidePrev();
        updateButtonStates();
      });
    });
    nextButtons.forEach(button => {
      button.addEventListener('click', () => {
        swiper.slideNext();
        updateButtonStates();
      });
    });

    // 修复分页点动画闪烁问题
    swiper.on('slideChange', function () {
      const activeBullet = document.querySelector(
        '.tw-product-features__pagination .swiper-pagination-bullet-active'
      );
      if (activeBullet) {
        activeBullet.classList.remove('swiper-pagination-bullet-active');
        void activeBullet.offsetWidth; // 触发重绘
        activeBullet.classList.add('swiper-pagination-bullet-active');
      }
      updateButtonStates();
    });

    // 初始化时更新按钮状态
    updateButtonStates();

    // 标记已初始化
    sliderContainer.dataset.initialized = 'true';
  } catch (error) {
    // 错误处理
  }
}

function applyHeaderSpacingToContainer() {
  const header = document.querySelector('.tenways-header.header.header--middle-left.page-width.header--has-menu');
  const featuresContainer = document.querySelector('.tw-product-features__container');

  if (!header || !featuresContainer) return;

  const headerStyle = window.getComputedStyle(header);
  const paddingLeft = parseFloat(headerStyle.paddingLeft) || 0;
  const marginLeft = parseFloat(headerStyle.marginLeft) || 0;
  const paddingRight = parseFloat(headerStyle.paddingRight) || 0;
  const marginRight = parseFloat(headerStyle.marginRight) || 0;

  const totalLeftSpacing = paddingLeft + marginLeft;
  const totalRightSpacing = paddingRight + marginRight;

  featuresContainer.style.paddingLeft = `${totalLeftSpacing}px`;
  featuresContainer.style.paddingRight = `${totalRightSpacing}px`;
}

function initSectionAnimation() {
  const section = document.querySelector('.tenways-product-features-section');
  if (!section) return;

  const observerOptions = {
    root: null,
    rootMargin: '-100px 0px -100px 0px',
    threshold: 0.2,
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('tenways-product-features-section--visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  observer.observe(section);
}